import React, { useState, useEffect, useImperativeHandle, useRef } from "react";
import { FileListHash } from "../../../context/UploadProvider/typesUpload";
import { readFileInChunks, UploadExistingFile, UploadFileChunk, UploadItem, VerifyItem } from "../../../services/Item/ItemUpload";
import { useUpload } from "../../../context/UploadProvider/useUpload";
import { useId } from '@fluentui/react-hooks'
import { useTranslation } from "react-i18next";
import styles from "./FileSwith.module.css";
import axios, { CancelTokenSource, AxiosError } from 'axios';
import { IIconProps, initializeIcons } from '@fluentui/react';
import { TooltipHost, ITooltipHostStyles } from '@fluentui/react/lib/Tooltip';
import { GetOneItem } from "../../../services/Item/ItemServicesGet";
import { AdminUserVO } from "../../../model/OrganizationModel";
import { CreateFolder } from "../../../services/Item/ItemServicesCRUD";
import WorkSpaceItemListFileComponentImage from "../../WorkSpaceItem/WorkSpaceItemListFileComponentImage";
import { IconButton, LinearProgress } from "@mui/material";
import { returnByteWithNotation } from "../../../utils/ReturnByteWithNotation";
import { PriorityHigh, Check, Delete, PauseCircle, Replay } from "@mui/icons-material";
import { UploadStatus } from "../../../enums/UploadStatus";
import { useParams } from "react-router-dom";
import { PaywallInformation } from "../../../model/PaywallModel";
import { GetStorageSizeByOrgInternalName } from "../../../services/OrganizationServices";

interface FileSwithProps {
  file: FileListHash;
  index: number;
  setLastIsDone: (index: number) => void;
  ref?: React.Ref<any>;
  newFolderFatherId?: string
  setOpenPaywallModal: React.Dispatch<React.SetStateAction<boolean>>
  indexToUpload: number | undefined;
  //uploadDone(): void;
  uploadCompleted?: number;
  setUploadCompleted?: React.Dispatch<React.SetStateAction<number>>;
  cancelUploadAll: boolean
  setAdminUserData: React.Dispatch<React.SetStateAction<AdminUserVO | undefined>>
  setPaywallInfo: (e: PaywallInformation) => void;
  paywallInfo: PaywallInformation;
  closeUpload: () => void;
}

export interface InterfaceFileIsDone {
  fileIsDone(): boolean;
}
const FileSwith: React.ForwardRefExoticComponent<FileSwithProps> =
  React.forwardRef(({ file, newFolderFatherId, setLastIsDone, index, closeUpload, setOpenPaywallModal, paywallInfo, setPaywallInfo, indexToUpload, uploadCompleted, setUploadCompleted, cancelUploadAll, setAdminUserData }, ref) => {
    const [percentCompleted, setPercentCompleted] = useState<number>(0);
    const upload = useUpload();
    const [status, setStatus] = useState<UploadStatus>(UploadStatus.INITIAL);
    const [isDone, setIsDone] = useState<boolean>(false);
    const [error, setError] = useState<string>("");
    const [folderId, setFolderId] = useState<string | undefined>(undefined);
    const [childrenIdUpload, setChildrenIdUpload] = useState<number | undefined>(undefined);
    const { t, i18n } = useTranslation();
    const [pauseUpload, setPauseUpload] = useState<boolean>(false);
    const pausedRef = useRef<boolean>(false);
    const [abortController, setAbortController] = useState<AbortController>(new AbortController());
    const { nameOrg, idWorkspace } = useParams();
    useEffect(() => {
      if (cancelUploadAll) {
        abortController.abort();
      }
    }, [cancelUploadAll]);

    function returnMessageStatusFile(status: UploadStatus) {
      let message;
      switch (status) {
        case UploadStatus.SUCCESS:
          message = t("FileUploader.UploadStatus.Success");
          break;
        case UploadStatus.ERROR:
          message = t("FileUploader.UploadStatus.Error");
          break;
        case UploadStatus.CANCELED:
          message = t("FileUploader.UploadStatus.Canceled");
          break;
        case UploadStatus.WARNING:
          message = t("FileUploader.UploadStatus.Warning");
          break;
        default:
          message = t("FileUploader.UploadStatus.Others");
          break;
      }
      return message;
    }

    useImperativeHandle(
      ref,
      () => ({
        fileIsDone() {
          if (file.folderWorkspace != undefined) {
            let doIt = true;
            let i: number = 0;
            for (i = 0; i < myRefs.current.length; i++) {
              if (myRefs.current[i].fileIsDone() == false) {
                doIt = false;
              }
            }

            return doIt;
          }
          else {
            return isDone;
          }
        },
      }),
    )

    async function fileUpload(
      file: FileListHash,
      signal?: AbortSignal
    ) {
      let uploadType: Promise<any> | undefined = undefined;
        const contractSize = await GetStorageSizeByOrgInternalName(nameOrg!);

        if (
          contractSize &&
          file.fileReplace === undefined &&
          file.fileWorkspace &&
          file.fileWorkspace.file &&
          contractSize.freeSpace < file.fileWorkspace.file.size
        ) {
          setPaywallInfo(paywallInfo);
          setOpenPaywallModal!(true);
          setError(t("Upload.notEnoughStorage"));
          
          closeUpload();
          return;
        }
              
      if (file.fileReplace !== undefined || file.fileWorkspace !== undefined) {
        var fileData = (file.fileReplace !== undefined ? file.fileReplace : file.fileWorkspace)?.file!
        var chunks = readFileInChunks(fileData);
        for (let i = 0; i < chunks.length; i++) {
          while (pausedRef.current) {
            await new Promise(resolve => setTimeout(resolve, 1000));
          }
          setPercentCompleted((i / chunks.length) * 100)
          await UploadFileChunk(chunks, i, fileData, signal)
            .catch((error) => {
              var params = JSON.stringify(error);
              if (params == "{}") {
                setStatus(UploadStatus.CANCELED)
                setError('Request canceled');
              }
            })

        }
      }

      if (file.fileReplace !== undefined) {
        uploadType = UploadExistingFile(file.fileReplace, signal);

      } else if (file.fileWorkspace != undefined) {
        const fileData = file.fileWorkspace.file;
        const lastDotIndex = fileData.name.lastIndexOf('.');

        let updatedFile: File;

        if (lastDotIndex !== -1) {
          const nameWithoutExtension = fileData.name.substring(0, lastDotIndex);
          const extensionLowerCase = fileData.name.substring(lastDotIndex).toLowerCase();
          const newFileName = nameWithoutExtension + extensionLowerCase;

          updatedFile = new File([fileData], newFileName, {
            type: fileData.type,
            lastModified: fileData.lastModified,
          });
        }

        const newFileWorkspace = {
          file: lastDotIndex !== -1 ? updatedFile! : file.fileWorkspace.file,
          woskpace: file.fileWorkspace.woskpace,
          folder: newFolderFatherId ?? file.fileWorkspace.folder
        }
        uploadType = UploadItem(newFileWorkspace, signal)
      }
      else if (file.folderWorkspace != undefined) {
        uploadType = CreateFolder({
          name: file.folderWorkspace.name,
          workspaceIdMongo:
            file.folderWorkspace.woskpace,
          idFatherMongo: newFolderFatherId ?? file.folderWorkspace.folder
        }, signal);
      }

      if (uploadType != undefined) {
        uploadType
          .then((alert) => {
            if (file.fileReplace != undefined) {
              GetOneItem(alert.data.itemId)
                .then(item => upload.setReplacedItem(item))
            }

            if (alert.supplementaryInfo) {
              setFolderId(alert.supplementaryInfo)
              setStatus(UploadStatus.SUCCESS)
            }

            if (alert != undefined && alert.data != undefined && alert.data.warningMessage != "") {
              setError(alert.data.warningMessage);
              setStatus(UploadStatus.WARNING)
            }
            else {
              setStatus(UploadStatus.SUCCESS)
            }

            if (alert && alert.data && alert.data.itemId) {
              upload.setItemId(alert.data.itemId);
            }
            upload.setShowEx(true);
            if (setUploadCompleted){
              setUploadCompleted(prevCount => prevCount + 1)
            }
          })
          .catch((error) => {
            if (axios.isCancel(error)) {
              console.log("Axios Cancel")
              console.log(error)
            }
            var params = JSON.stringify(error);
            if (params == "{}") {
              setStatus(UploadStatus.CANCELED)
              setError('Request canceled');
            }
            else {
              setStatus(UploadStatus.ERROR)
              if (error.response && error.response.data && typeof error.response.data === 'string') {
                setError(error.response.data);
              }
              else if (error.response && error.response.data && typeof error.response.data !== 'string') {
                const data = error.response.data;
                if (typeof data.name === 'string' && typeof data.email === 'string' && typeof data.userLoggedIsNotAdmin === 'boolean') {
                  const adminUserVO: AdminUserVO = data;
                  setAdminUserData(adminUserVO);
                  setOpenPaywallModal!(true);
                  setError(t("Upload.notEnoughStorage"));
                }
              } else {
                setError(t("Upload.error"));
              }
            }
            upload.setShowEx(true);

            if (setUploadCompleted){
              console.log("Removido")
              setUploadCompleted(prevCount => prevCount + 1)
            }
          })
          .finally(() => {
            finalizeUpload(file);
          });
      }
    }

    function finalizeUpload(file: FileListHash) {
      if (file.folderWorkspace != undefined && file.folderWorkspace.itens.length > 0) {
        setChildrenIdUpload(0);
      }
      setIsDone(true);
      setLastIsDone(index);
    }

    useEffect(() => {
      if (
        file != undefined &&
        file.uploadDone == false &&
        status == UploadStatus.INITIAL &&
        ((file.fileReplace != undefined && file.fileReplace.file) ||
          (file.fileWorkspace != undefined && file.fileWorkspace.file) ||
          file.folderWorkspace != undefined)
      ) {
        fileUpload(file, abortController.signal);
      }
    }, [file]);

    const endstyle: React.CSSProperties = {
      color: "#bdffc3",
      fontSize: 20
    }

    const errorstyle: React.CSSProperties = {
      color: "#fca2a2",
      fontSize: 20
    }

    const alertStyle: React.CSSProperties = {
      color: "#fcba03",
      fontSize: 20
    }

    const tooltipId = useId('tooltip');
    const calloutProps = { gapSpace: 0 };
    const hostStyles: Partial<ITooltipHostStyles> = { root: { display: 'inline-block' } };

    function cancel() {
      if (upload.fileList && upload.fileList.length == 1 && upload.fileList[0].fileWorkspace) {
        upload.clear()
      }
      if (pausedRef.current && pauseUpload) {
        changePause();
      }
      abortController.abort()
    }

    function changePause() {
      setPauseUpload(!pauseUpload); pausedRef.current = !pausedRef.current;
    }

    function tryAgain() {
      if (!file.uploadDone) {
        file.uploadDone = !file.uploadDone
      }
      if (status != UploadStatus.INITIAL) {
        setStatus(UploadStatus.INITIAL);
      }
      if (isDone) {
        setIsDone(!isDone)
      }

      if (
        file != undefined &&
        ((file.fileReplace != undefined && file.fileReplace.file) ||
          (file.fileWorkspace != undefined && file.fileWorkspace.file) ||
          file.folderWorkspace != undefined)
      ) {
        fileUpload(file, abortController.signal);
      }
    }

    const myRefs = useRef<any[]>([]);

    useEffect(() => {
      if (file.folderWorkspace != undefined && file.folderWorkspace.itens.length > 0) {
        myRefs.current = myRefs.current.slice(0, file.folderWorkspace.itens.length);
      }
      else {
        myRefs.current = myRefs.current.slice(0, 0);
      }
    }, [file.folderWorkspace]);

    return (
      <>
        {status != UploadStatus.CANCELED &&
          <div style={{
            borderBottom: "1px solid rgb(213, 213, 213)",
            maxHeight: "96px",
            minHeight: "59px",
            padding: "12px 9px",
            display: "flex",
            flexDirection: "column",
            gap: "10px"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "10px"

            }}>
              <div style={{
                width: "34px",
                height: "34px",
                background: "#E9EFF4",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "2px"
              }}>
                <WorkSpaceItemListFileComponentImage boxLayout isFolder={file.folderWorkspace != undefined} extension={file.folderWorkspace != undefined ? "" : (file.fileWorkspace ?? file.fileReplace)?.file.name.split(".")[1]} />
              </div>
              <div style={{
                width: "100%"
              }}>
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%"
                }}>
                  <div style={{
                    width: "165px",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    font: "normal normal 600 14px / 21px Segoe UI",
                    color: "#2D2D2D",
                    height: "19px"
                  }}>
                    <TooltipHost
                      content={(file.folderWorkspace != undefined ? file.folderWorkspace.name : file.fileWorkspace != undefined ? file.fileWorkspace.file.name : file.fileReplace != undefined ? file.fileReplace.file.name : "")}
                      id={tooltipId}
                      calloutProps={calloutProps}
                      styles={hostStyles}
                    >

                      {file.folderWorkspace != undefined && file.folderWorkspace.name + " "}
                      {file.fileWorkspace != undefined && file.fileWorkspace.file.name + " "}
                      {file.fileReplace != undefined && file.fileReplace.file.name + " "}
                    </TooltipHost>
                  </div>
                  {
                    (status == UploadStatus.ERROR) &&
                    <IconButton sx={{
                      width: "12px",
                      height: "12px"
                    }}
                      onClick={tryAgain}>
                      <Replay sx={{
                        width: "20px",
                        height: "20px"
                      }} />
                    </IconButton>
                  }
                  {!isDone &&
                    <div>
                      {(!pauseUpload) ?
                        <IconButton sx={{
                          width: "12px",
                          height: "12px"
                        }}
                          onClick={changePause} >
                          <PauseCircle sx={{
                            width: "20px",
                            height: "20px"
                          }} />
                        </IconButton>
                        : <IconButton sx={{
                          width: "12px",
                          height: "12px"
                        }}
                          onClick={changePause}>
                          <Replay sx={{
                            width: "20px",
                            height: "20px"
                          }} />
                        </IconButton>}
                      <IconButton sx={{
                        width: "12px",
                        height: "12px"
                      }}
                        onClick={cancel}>
                        <Delete sx={{
                          width: "20px",
                          height: "20px"
                        }} />
                      </IconButton>
                    </div>}
                </div>
                <div style={{
                  font: "normal normal normal 12px / 18px Segoe UI",
                  height: "16px",
                  color: status == UploadStatus.INITIAL ? "#969696" : status == UploadStatus.SUCCESS ? "#62AC00" : status == UploadStatus.WARNING ? "#faad14" : "#BF1111"
                }}>
                  {
                    (status == UploadStatus.INITIAL) ?
                      (file.folderWorkspace == undefined) && returnByteWithNotation((file.fileWorkspace ?? file.fileReplace)?.file.size)
                      :
                      <TooltipHost
                        content={status == UploadStatus.SUCCESS ? t("Upload.done") : error}
                        id={tooltipId}
                        calloutProps={calloutProps}
                        styles={hostStyles}
                      >
                        <div style={{ display: "flex" }}>
                          {returnMessageStatusFile(status)}
                          {status == UploadStatus.SUCCESS ? <Check sx={{ fontSize: "18px" }} /> : <PriorityHigh sx={{ fontSize: "18px" }} />}
                        </div>
                      </TooltipHost>
                  }
                </div>
              </div>
            </div>

            {!isDone &&
              <div>
                <LinearProgress sx={{
                  height: "6px",
                  backgroundColor: "#eaeaea",
                  "& .MuiLinearProgress-bar": {
                    background: "#22638D"
                  }
                }} variant="determinate" value={percentCompleted} />
                <div style={{
                  display: "flex",
                  justifyContent: "space-between"
                }}>
                  <div style={{
                    font: "normal normal normal 12px / 18px Segoe UI",
                    height: "16px",
                    color: "#969696"
                  }}>
                    {
                      percentCompleted ?
                        returnByteWithNotation((((file.fileWorkspace ?? file.fileReplace)?.file.size! / 100) * percentCompleted))
                        + ` ${t("FileUploader.Of")} `
                        + returnByteWithNotation((file.fileWorkspace ?? file.fileReplace)?.file.size)
                        : t("FileUploader.Waiting")
                    }
                  </div>
                  <div style={{
                    font: "normal normal 600 12px / 18px Segoe UI",
                    height: "16px",
                    color: "#2D2D2D"
                  }}>
                    {Math.round(percentCompleted)}%
                  </div>
                </div>
              </div>
            }
          </div>
        }
        {file.folderWorkspace != undefined && file.folderWorkspace.itens.length > 0 && folderId != undefined && (
          <>
            {file.folderWorkspace.itens.map((itens, index) => (
              <FileSwith
                key={index}
                file={itens}
                index={index}
                setLastIsDone={setLastIsDone}
                ref={el => myRefs.current[index] = el}
                newFolderFatherId={folderId}
                setOpenPaywallModal={setOpenPaywallModal}
                indexToUpload={childrenIdUpload}
                setAdminUserData={setAdminUserData}
                uploadCompleted={uploadCompleted}
                setUploadCompleted={setUploadCompleted}
                cancelUploadAll={cancelUploadAll}
                setPaywallInfo={setPaywallInfo}
                paywallInfo={paywallInfo}
                closeUpload={closeUpload}
              />
            ))}
          </>
        )
        }

      </>
    );
  });

export default FileSwith;

